module.exports = __webpack_public_path__ + "static/media/40.77f3fe6e.JPG";